export const classBase = "uitkAvatar";
